import { useContext, useEffect } from 'react';
import { DatafeedAction, DatafeedContext } from '.';

const useDatafeedMessageEffect = (
  channel: keyof DatafeedMessageChannel,
  key: string,
  action?: DatafeedAction,
) => {
  const { setAction, removeAction } = useContext(DatafeedContext);

  useEffect(() => {
    if (action) {
      setAction(channel, key, action);
      return () => removeAction(channel, key);
    }
  }, [channel, key, action]);
};

export default useDatafeedMessageEffect;
